import { useEffect, useState } from 'react';
import { config } from '../config';
import { checkServer, type ServerStatus } from './serverClient';

export function useServerStatus(): ServerStatus {
  const [status, setStatus] = useState<ServerStatus>(
    config.serverUrl ? { state: 'checking' } : { state: 'unconfigured' },
  );

  useEffect(() => {
    let cancelled = false;
    const update = (s: ServerStatus) => {
      if (!cancelled) setStatus(s);
    };
    void checkServer(config.serverUrl, update).then(update);
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
}
